import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import TextArea from '../formInputs/textArea/textArea';

const initialValues = {
  description: '',
};

const RecordDescription = ({ onSubmit, formReference }) => {
  const validationSchema = Yup.object({
    description: Yup.string(),
  });

  return (
    <Formik
      innerRef={formReference}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {
        ({
          values,
          handleChange,
          handleBlur,
        }) => (
          <TextArea
            name="description"
            id="description"
            placeholder="Start typing…"
            handleChange={handleChange}
            handleBlur={handleBlur}
            values={values}
            maxLength="50"
            canResize={false}
          />
        )
      }

    </Formik>
  );
};

RecordDescription.propTypes = {
  onSubmit: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  formReference: PropTypes.object.isRequired,
};

export default RecordDescription;
